import { formatMilBillion, formatMoney, numericValue, percentDecimal } from '../utils';

const healthCareCalculator = ({ sliderMin, sliderMax, sliderDefault }) => {
    return {
        sliderMin,
        sliderMax,

        patientRevenue: sliderDefault,
        patientRevenueMB: formatMilBillion(sliderDefault),

        finalPercent: 0,

        rows: [],

        get fullPatientRevenue() {
            let amount = numericValue(this.patientRevenue);

            if (amount < 1000000) {
                amount = amount * 1000000;
            }

            return amount;
        },

        get finalValue() {
            return this.fullPatientRevenue * percentDecimal(this.finalPercent);
        },

        get finalTotal() {
            return formatMoney(this.finalValue);
        },

        get chartMaxValue() {
            return Math.max(
                ...this.channelsRows
                    .map((row) => [
                        this.finalValue * this.percentDecimal(row.percentWithFlywire),
                        this.finalValue * this.percentDecimal(row.percentWithoutFlywire),
                    ])
                    .flat()
            );
        },

        get currentTotals() {
            return this.calculateRows(
                [
                    `patientResponsibility`,
                    `balanceTransfers`,
                    `patientDiscounting`,
                    `writeOffRecoveries`,
                    `extendPaymentPlans`,
                ],
                `current`
            );
        },

        get withFlywireTotals() {
            return this.calculateRows(
                [
                    `patientResponsibility`,
                    `balanceTransfers`,
                    `patientDiscounting`,
                    `writeOffRecoveries`,
                    `extendPaymentPlans`,
                ],
                `withFlywire`
            );
        },

        formatMilBillion,
        formatMoney,
        numericValue,
        percentDecimal,

        updatePatientRevenue() {
            let amount = numericValue(this.patientRevenueMB, 3);
            if (amount > 1000000) {
                amount = amount / 1000000;
            }

            this.patientRevenue = amount;
        },

        calculateFinalPercent(arr) {
            return arr.reduce((acc, val, idx) => (idx === 0 ? val.percentage : acc - val.percentage), 0);
        },

        //-- Row Management ------------------------------------------------
        addRow(row) {
            this.rows.push(row);
        },

        getRowById(id) {
            return this.rows.find((r) => r.id === id);
        },

        getRowByIds(ids) {
            return this.rows.filter((r) => ids.includes(r.id));
        },

        getRows() {
            return this.rows;
        },

        calculateRows(ids, withMethod = `current`) {
            const method = withMethod === `withFlywire` ? `withFlywire` : `current`;

            const rows = this.getRowByIds(ids);
            const total = rows.reduce((total, row) => {
                if (row.operator === `–`) {
                    return total - (row[method]() || 0);
                }
                return total + (row[method]() || 0);
            }, 0);
            return total;
        },

        init() {
            this.patientRevenue = sliderDefault;
            this.patientRevenueMB = formatMilBillion(this.patientRevenue);
        },
    };
};

export default healthCareCalculator;
